<template lang="">
  <div id="footer_page">
    <div class="container">
      <div class="f_content">
        <div class="foot_left">
          <img :src="siteList.footer_logo" alt="">
          <div class="foot_info">
            <span>佛山招商电话：{{siteList.phone}}</span>
            <span>传真：{{siteList.fax}}</span>
            <div>地址：{{siteList.address}}</div>
          </div>
        </div>
        <div class="foot_right">
          <div class="foot_info2">
            <div>
              <ul>
                <li>
                  <router-link to="">首页</router-link>
                </li>
                <li v-for="(item,index) in navList" :key="index">
                  <router-link to="">{{item.title}}</router-link>
                </li>
              </ul>
              <span style="margin-top:15px ; display: block; width: 100%; color: #3C4049; text-align: right;">
                {{siteList.copyright}}@2024版权所有 {{siteList.icp_number}}
              </span>
            </div>
            <img :src="siteList.code" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['navList','siteList'],
    mounted() {
     setTimeout(() => {
      console.log(this.siteList,'1');
     }, 500);
    },
  }
</script>
<style lang="">

</style>